import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableAcknowledgementPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableAcknowledgementPage;
